import { Routes } from '@angular/router';
import { AuthGuard } from '@app/core/guards/auth.guard';
import { LayoutComponent } from '@app/features/layout/layout.component';
import { LoginComponent } from '@app/features/login/login.component';
import { NotFoundComponent } from '@app/features/not-found/not-found.component';
import { OperationsLayoutComponent } from '@app/features/operations/operations-layout/operations-layout.component';
import { ReservationsComponent } from '@app/features/operations/reservations/reservations.component';
import { RentalAgreementsComponent } from '@app/features/operations/rental-agreements/rental-agreements.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'operations', pathMatch: 'full' },
      {
        path: 'operations',
        component: OperationsLayoutComponent,
        children: [
          { path: '', redirectTo: 'reservations', pathMatch: 'full' },
          { path: 'reservations', component: ReservationsComponent },
          { path: 'rental-agreements', component: RentalAgreementsComponent }
        ]
      }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' }
];
